import axios from 'axios';
import { apiUrl, execUrl, isKNBank } from 'libs/commonVar';
import * as common from 'libs/commonFunc';

export const getExam = params => common.requestRaw(apiUrl + 'Exam', params, 'get');
export const postExam = params => common.requestRaw(apiUrl + 'Exam', params, 'post');
export const putExam = params => common.requestRaw(apiUrl + 'Exam', params, 'put');
export const deleteExam = params => common.requestRaw(apiUrl + 'Exam', params, 'delete');

export const startExam = params => common.requestRaw(apiUrl + 'Exam', params, 'post');
export const resendExam = params => common.requestRaw(apiUrl + 'Exam', params, 'post');
export const prepareExam = params => common.requestRaw(apiUrl + 'Exam/Prepare', params, 'get');

export const getExamChart = params => common.requestRaw(apiUrl + 'Exam/ExamChart', params, 'get');

export const getExamList = params => common.requestRaw(apiUrl + 'Exam/ExamList', params, 'get');

export const getExamTarget = params => common.requestRaw(apiUrl + 'Exam/ExamTarget', params, 'get');

export const getInfectionTarget = params => common.requestRaw(apiUrl + 'Exam/InfectionTarget', params, 'get');
export const getInfectionPC = params => common.requestRaw(apiUrl + 'Exam/InfectionPC', params, 'get');

// 훈련메일 재전송
export const putExamResend = params => common.requestRaw(apiUrl + 'Exam/ExamResend', params, 'put');

// 결과보기 태그별 대상자 목록
export const getTargetListByTag = params => common.requestRaw(apiUrl + 'Exam/TargetListByTag', params, 'get');

// 결과보기 태그 만들기
export const postAddTag = params => common.requestRaw(apiUrl + 'Exam/AddTag', params, 'post');

// 훈련 일시 정지
export const postExamPause = params => common.requestRaw(apiUrl + 'Exam/Suspend', params, 'post');

// 훈련 실시 - 라이센스 정보 조회
export const getExamLicense = params => common.requestRaw(apiUrl + 'Exam/ExamLicense', params, 'get');

// 결과보기 보고서 다운로드
export function downloadExamReport(params) {
  return axios({
    method: 'post',
    headers: {
      'Content-Type': 'application/vnd.openxmlformats'
    },
    responseType: 'arraybuffer',
    url: apiUrl + 'Exam/DownloadExamReport',
    data: params
  });
}

// 백신 다운로드
export function downloadVaccine() {
  return axios({
    method: 'get',
    headers: {
      'Content-Type': 'application/vnd.openxmlformats'
    },
    responseType: 'arraybuffer',
    url: execUrl + 'Cure'
  });
}

// 백신 메일 발송
export const sendVaccine = params =>
  common.requestRaw(execUrl + (isKNBank ? 'SendVaccineKNBank' : 'SendVaccine'), params, 'get');



// WEBPACK FOOTER //
// ./src/script/libs/examLib.js